<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <transition-group name="fade" v-if="receivedMessages.length">
          <div
            class="notification"
            :class="{ read: message.is_read == true }"
            v-for="(message, index) in receivedMessages"
            :key="'k' + index"
            @click="showItem(message)"
          >
            <router-link
              :to="'/games/show/' + message.notification_id"
              v-if="message.notification_type == 'game'"
            >
              <div>
                <h3>{{ message.title }}</h3>
                {{ message.type }}
                <p>{{ message.body }}</p>

                <!-- @click="DeleteNotification(message.id)" -->

                <!-- </router-link> -->
                <div
                  class="delete_notification"
                  :class="{ read: message.is_read }"
                  @click="NotificationsReaded(message.id)"
                >
                  <i class="fas fa-check-double"></i>
                </div>
              </div>
            </router-link>

            <div v-else>
              <h3>{{ message.title }}</h3>
              {{ message.type }}
              <p>{{ message.body }}</p>

              <!-- @click="DeleteNotification(message.id)" -->

              <!-- </router-link> -->
              <div
                class="delete_notification"
                :class="{ read: message.is_read }"
                @click="NotificationsReaded(message.id)"
              >
                <i class="fas fa-check-double"></i>
              </div>
            </div>

            <!-- <router-link v-else :to="message.type === 'user_register' ? '/users/all' : message.type === 'new_message' ? '/contact-messages/all' : message.type === 'charge_wallet' ? '/users/all' : message.type === 'Addition_Service' ? '/services/all' : message.type === 'Reject_Addition_Service' ? '/services/all' : message.type === 'wallet_request' ? '/RequestWallets/all' : ''">
              <h3>{{ message.title }}</h3>
              <p>{{ message.body }}</p>
            </router-link> -->
            <div
              class="delete_notification"
              :class="{ read: message.is_read }"
              @click="NotificationsReaded(message.id)"
            >
              <i class="fas fa-check-double"></i>
            </div>
          </div>
        </transition-group>

        <p class="text-danger text-center text--darken-4 pt-5 pb-5" v-else>
          {{ $t("PLACEHOLDERS.no_notifications") }}
        </p>

        <!-- Start:: Pagination -->
        <template>
          <div class="pagination_container text-center mt-3 mb-0">
            <v-pagination
              class="py-0"
              square
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="6"
              @input="updateRouterQueryParam($event)"
              :prev-icon="
                getAppLocale == 'ar'
                  ? 'fal fa-angle-right'
                  : 'fal fa-angle-left'
              "
              :next-icon="
                getAppLocale == 'ar'
                  ? 'fal fa-angle-left'
                  : 'fal fa-angle-right'
              "
            />
          </div>
        </template>
        <!-- End:: Pagination -->
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateContact",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      receivedMessages: [],

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      notificationsData: "NotificationsModule/notificationsData",
    }),
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.getData();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    ...mapActions({
      readAllNotifications: "NotificationsModule/readAllNotifications",
    }),
    showItem(item) {
      // console.log(item);

      // public const ADMIN_NOTIFICATION = 'admin_notification';
      // public const ROLE = 'role';
      // public const ADVERTISEMENT_REQUEST = 'advertisement_request';
      // public const SUBSCRIPTION = 'subscription';
      // public const WITHDRAW_REQUEST = 'withdraw_request';
      // public const PROVIDER = 'provider';
      // public const WALLET = 'wallet';
      // public const CLIENT = 'client';
      // public const CONTACT = 'contact';
      // public const ORDER = 'order';
      // public const RATE = 'rate';

      if (item.data.type === "order" || item.data.type === "rate") {
        this.$router.push({ path: `/orders/show/${item.data.id}` });
      }
      if (item.data.type === "contact") {
        this.$router.push({ path: `/contact-messages/show/${item.data.id}` });
      }
      if (item.data.type === "withdraw_request") {
        this.$router.push({ path: `/request-wallets/all` });
      }
      if (item.data.type === "subscription") {
        this.$router.push({ path: `/subscriptions/all` });
      }
      if (item.data.type === "advertisement_request") {
        this.$router.push({ path: `/advertisement/all` });
      }
      if (item.data.type === "wallet") {
        this.$router.push({ path: `/providers/show/${item.data.id}` });
      }
      if (item.data.type === "provider") {
        this.$router.push({ path: `/providers/show/${item.data.id}` });
      }
      if (item.data.type === "provider_register") {
        this.$router.push({ path: `/join-providers/all` });
      }
      if (item.data.type === "client") {
        this.$router.push({ path: `/clients/all` });
      }
      if (item.data.type === "role") {
        this.$router.push({ path: `/role/all` });
      }
      if (item.data.type === "admin_notification") {
        this.$router.push({ path: `/all-notifications/all` });
      }
      // this.$router.push({ path: `/all-notifications/show/${item.id}` });
    },
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "notification/user-notifications",
          params: {
            page: this.paginations.current_page,
          },
        });

        console.log("notification_id", res.data.data);
        this.receivedMessages = res.data.data.notifications.data;
        this.paginations.last_page = res.data.data.notifications.meta.last_page;
        this.paginations.items_per_page =
          res.data.data.notifications.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    // async DeleteNotification(item_id) {
    //   const REQUEST_DATA = new FormData();
    //   REQUEST_DATA.append("_method", "PUT");
    //   try {
    //     let res = await this.$axios({
    //       method: "POST",
    //       url: `notifications/${item_id}`,
    //       params: REQUEST_DATA,
    //     });
    //     this.$message.success(res.data.message);
    //     this.getData();
    //   } catch (error) {
    //     this.dialogDelete = false;
    //     this.$message.error(error.response.data.errors);
    //   }
    // },

    async NotificationsReaded(item_id) {
      try {
        const REQUEST_DATA = new FormData();

        REQUEST_DATA.append("notification_id", `${item_id}`);

        let res = await this.$axios({
          method: "POST",
          url: `notification/mark-as-read`,
          data: REQUEST_DATA,
        });

        this.$message.success(res.data.message);
        // Update the local state for the specific message
        const message = this.receivedMessages.find((msg) => msg.id === item_id);

        if (message) {
          message.read = true;
        }

        this.getData();
        this.readAllNotifications();
        this.notificationsData.unreadNotifications--;
      } catch (error) {
        this.$message.error(error.response.data.errors);
      }
    },
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },

  created() {
    this.getData();

    navigator.serviceWorker.addEventListener("message", (event) => {
      const receivedMessage = event.data.data;

      this.receivedMessages.unshift(receivedMessage);

      console.log(event.data.data);
      // console.log("receivedMessage", event)
      // Update component state or display the received message in the UI
    });

    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.show_order {
  cursor: pointer;
  i {
    font-size: 20px;
    position: absolute;
    top: 20px;
    left: 60px;
  }
}
.notification {
  background: #000;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
  position: relative;

  .delete_notification {
    position: absolute;
    z-index: 500 !important;
    top: 20px;
    left: 20px;
    cursor: pointer;

    &.read {
      i {
        color: #49a956;
      }
    }

    i {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.text-danger {
  font-size: 22px;
}
</style>
